var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangSeFlagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 24 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Swedish flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change-language-dropdown",
    transform: "translate(-43.000000, -41.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(26.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_Sweden",
    transform: "translate(17.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#006AA7",
    x: 0,
    y: 0,
    width: 24,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FECC00",
    x: 7.5,
    y: 0,
    width: 3,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FECC00",
    x: 0,
    y: 6,
    width: 24,
    height: 3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangSeFlagIcon);
export default __webpack_public_path__ + "static/media/LangSeFlagIcon.2e134bff444b121da5b8892a6b79974a.svg";
export { ForwardRef as ReactComponent };